import { $patrimoine } from 'src/boot/patrimoineDB'
import Promise from 'bluebird'

export const AuditService = {
  getAllAudits: async () => {
    const docs = await $patrimoine
      .auditsCollection()
      .allDocs({ include_docs: true })
    return docs.rows
      .map((row) => row.doc)
      .filter((row) => row.id && !row._deleted)
  },
  clearAudits: async () => {
    await $patrimoine.clearAuditsCollection()
  },
  resetAllAudits: async (allAudits = []) => {
    await AuditService.clearAudits()
    await AuditService.saveAudits(allAudits)
  },
  saveAudits: async (audits) => {
    return await Promise.each(audits, async (audit) => {
      // NOTE: un audit sans checkpoints persisté en local resterait bloqué :
      // la synchro ne re-télécharge que les audits absents (diff par id)
      if (!Array.isArray(audit.checkpoints) || !audit.checkpoints.length) {
        console.error(
          `saveAudits: audit ${audit.id} reçu sans checkpoints, non persisté`
        )
        return
      }
      const storedAudit = await $patrimoine
        .auditsCollection()
        .get(`${audit.id}`)
        .catch(() => {})
      await $patrimoine
        .auditsCollection()
        .put(
          {
            _id: `${audit.id}`,
            _rev: storedAudit ? storedAudit._rev : undefined,
            ...audit
          },
          { force: true }
        )
        .catch((err) => {
          console.error(
            '🚀 ~ file: index.js:134 ~ returnawaitPromise.each ~ err:',
            err
          )
        })
    })
  },
  closeAudit: async (audit) => {
    const storedAudit = await $patrimoine.auditsCollection().get(`${audit.id}`)
    if (storedAudit) {
      await $patrimoine.auditsCollection().remove(storedAudit)
    }
  }
}
